import styled from "styled-components"

export const FooterContainer = styled.div`  
    border-top: 1px solid #999999;
    padding-top: 20px;
    margin-top: 20px;
`;